export interface FaqItem {
  id: string;
  question: string;
  answer: string;
}

export const faqItems: FaqItem[] = [
  {
    id: 'faq-1',
    question: '亚洲免费在线平台上的资源真的全部免费吗？',
    answer: '是的，我们平台推荐的所有资源均提供免费使用方案。部分工具或平台可能提供高级付费功能，但基础免费版本已能充分满足日常使用需求。我们会持续更新资源信息，确保推荐的每个资源都真实有效且保持免费可用。',
  },
  {
    id: 'faq-2',
    question: '如何快速找到我需要的免费资源？',
    answer: '您可以通过多种方式查找资源：使用顶部的分类导航浏览感兴趣的类别；在首页查看热门推荐和最新文章；利用搜索功能输入关键词查找特定资源。我们还设置了精选标签系统，帮助您更精准地定位所需内容。',
  },
  {
    id: 'faq-3',
    question: '平台推荐的资源是否安全可靠？',
    answer: '我们非常重视资源的安全性和可靠性。每一篇推荐文章都经过编辑团队的实际测试和验证，确保推荐的在线工具和平台来源正规、使用安全。同时，我们也会注明每个资源的使用条款和限制条件，帮助用户做出明智选择。',
  },
  {
    id: 'faq-4',
    question: '平台内容多久更新一次？',
    answer: '我们的编辑团队保持每周至少发布3-5篇新文章，并定期回顾和更新已有内容。当某个免费资源的政策或功能发生重大变化时，我们会第一时间更新相关信息。建议订阅我们的资讯邮件，不错过任何新资源推荐。',
  },
  {
    id: 'faq-5',
    question: '我可以在自己的网站上分享亚洲免费在线的文章吗？',
    answer: '欢迎分享我们的内容！您可以在遵守知识共享协议的前提下，以链接形式分享或引用我们的文章内容。如需转载全文，请注明出处并保留原文链接。未经授权，禁止将我们的内容用于商业目的或大量复制。',
  },
  {
    id: 'faq-6',
    question: '如何推荐未被收录的免费资源？',
    answer: '我们非常欢迎用户推荐优质的免费资源！您可以通过"关于我们"页面的联系表单提交资源推荐，也可以在文章评论区留下您的建议。编辑团队会认真评估每一份推荐，符合收录标准的资源将在审核后发布。',
  },
];